import { ItarianService } from './ItarianService';

const itarianService = new ItarianService();

export { itarianService };
